import { Component, OnInit, ElementRef, ViewChild, Input, EventEmitter, HostListener, OnDestroy, Renderer2, AfterViewInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpParams } from '@angular/common/http';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormGroupDirective } from '@angular/forms';
import { UiHelper } from '@helpers/ui.helper';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { TranslateService } from '@services/translate.service';
import { VirtualScrollerComponent } from 'ngx-virtual-scroller';
import { DimmerService } from '@services/dimmer.service';

@Component({
  selector: 'forgot-password',
  templateUrl: '../sharedTemplates/forgot-password.component.html',
})
export class ForgotPasswordComponent implements OnInit, AfterViewInit {
  @ViewChild('outsideOverlay') outsideOverlay: any;

  forgotPasswordDatas: UntypedFormGroup;
  forgotPasswordDataRaw: any;
  startDate = new Date(new Date().getFullYear() - 18, 0, 1);
  endDate = new Date();
  constructor(
    public _UiHelper: UiHelper,
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    private _LocalizationService: LocalizationService,
    private _TranslateService: TranslateService,
    public _DimmerService: DimmerService
  ) {
    this.forgotPasswordDatas = _FormBuilder.group({
      email: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.email, Validators.minLength(3)]),
      birthDay: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(3)]),
    });
  }

  ngOnInit() {
    this.forgotPasswordDatas.valueChanges.subscribe(x => {
      this.forgotPasswordDataRaw = x;
    });
  }

  ngAfterViewInit() {
    if (this._UiHelper.rightMenu) {
      this._UiHelper.setRightMenu();
    }
  }

  submitForgotPasswordData() {
    this._ApiService.forgotPassword(this.forgotPasswordDataRaw).then(result => {
      if (result.code == '') {
        return 'error|System Error';
      } else {
        if (result.code == 'error') {
          this._UiHelper.errorSnackBar(result.message, '');
        } else if (result.code == 'errorcode') {
          const t_message = this._TranslateService.instant(result.message);

          this._UiHelper.errorSnackBar(t_message, '');
        } else if (result.code == 'success') {
          this._UiHelper.successSnackBar(result.message, '');
          this.forgotPasswordDatas.controls.email.disable();
          this.forgotPasswordDatas.reset();
          this._UiHelper.forgotPass = true;
          this._UiHelper.toogleForgotPass();
        }
      }
    });
  }

  submitForgotPasswordData2() {
    this._ApiService.forgotPassword2(this.forgotPasswordDataRaw).then(result => {
      if (result.code == '') {
        return 'error|System Error';
      } else {
        if (result.code == 'error') {
          this._UiHelper.errorSnackBar(result.message, '');
        } else if (result.code == 'errorcode') {
          const t_message = this._TranslateService.instant(result.message);

          this._UiHelper.errorSnackBar(t_message, '');
        } else if (result.code == 'success') {
          this._UiHelper.successSnackBar(result.message, '');

          this.forgotPasswordDatas.reset();
          this._UiHelper.forgotPass = true;
          this._UiHelper.toogleForgotPass();
        }
      }
    });
  }
  handleOutside(event) {
    if (event.targetElement === this.outsideOverlay.nativeElement) {
      this._UiHelper.toogleForgotPass();
    }
  }
}
